import { render, staticRenderFns } from "./Passbook.vue?vue&type=template&id=0af3382e&scoped=true&"
import script from "./Passbook.vue?vue&type=script&lang=js&"
export * from "./Passbook.vue?vue&type=script&lang=js&"
import style0 from "./Passbook.vue?vue&type=style&index=0&id=0af3382e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3382e",
  null
  
)

export default component.exports